// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_main_container_file__s9mXr, .style_pagination__XIdWV button, .style_pagination__XIdWV div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_main_container_file_box__v5YiM, .style_interface_heading_row__uqn1C {
  display: flex;
  align-items: center;
}

.style_main__zvidG, .style_interface_noResults__LMlGP {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_main_loadingProcess__jr1Ts {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.style_main_loadingProcess_text__1S9O2, .style_interface__8eUNM {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__EUpCY {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__EUpCY:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__Xtxjv {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__Ls-5f {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__ZlXDn, .style_interface_heading__K6KK5, .style_interface_footer__zwMjm {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__15Eqj {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__mlgWy {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__mlgWy {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__0vCMt {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__0vCMt {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__5QNE9 {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__5QNE9 {
    line-height: 1.5rem;
  }
}

.style_breadcumb__8VDkq {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__8VDkq a,
.style_breadcumb__8VDkq span {
  padding: 3px 5px;
}
.style_breadcumb__8VDkq a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__8VDkq a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__8VDkq .style_divider__7rjmZ {
  color: var(--color-gray-400);
}

.style_badge__Ngccm {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__Ngccm.style_xs__3JeHE {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__Ngccm.style_sm__aTCsi {
  padding: 4px 7px;
}
.style_badge__Ngccm.style_primary__0UNZ- {
  background: var(--color-primary-500);
}
.style_badge__Ngccm.style_primary__0UNZ-, .style_badge__Ngccm.style_pm__OViGf {
  background: var(--color-primary-500);
}
.style_badge__Ngccm.style_sd__j6p3H {
  background-color: var(--color-secundary-500);
}
.style_badge__Ngccm.style_Likely__6ywQE {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__Ngccm.style_Unvalidated__k6gmN {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__Ngccm.style_Verified__AyrgH, .style_badge__Ngccm.style_green__72aDW {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__Ngccm.style_off__KHVvi {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__OgKko {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__OgKko.style_xs__3JeHE {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__OgKko.style_sm__aTCsi {
  padding: 4px 7px;
}
.style_badgeTable__OgKko.style_primary__0UNZ-, .style_badgeTable__OgKko.style_pm__OViGf {
  background: var(--color-primary-500);
}
.style_badgeTable__OgKko.style_sd__j6p3H {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__OgKko.style_Likely__6ywQE {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__OgKko.style_Verified__AyrgH, .style_badgeTable__OgKko.style_green__72aDW {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__OgKko.style_off__KHVvi {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__CHLCd {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__CHLCd.style_style-1__F225W td,
.style_table__CHLCd.style_style-1__F225W th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__CHLCd.style_style-1__F225W th,
.style_table__CHLCd.style_style-1__F225W td.style_label__C\\+u0u {
  color: var(--color-white-500);
}
.style_table__CHLCd.style_style-1__F225W th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__CHLCd.style_style-1__F225W tr.style_noBorder__z2V9f td {
  border-bottom: none;
}
.style_table__CHLCd.style_style-1__F225W tr td {
  color: var(--color-white-500);
}

.style_pagination__XIdWV {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__XIdWV button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__XIdWV button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__XIdWV button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__XIdWV button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__XIdWV button.style_disabled__ASDED, .style_pagination__XIdWV button.style_active__OEW5p, .style_pagination__XIdWV button.style_info__badzj {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__XIdWV button.style_disabled__ASDED {
  color: var(--color-gray-700);
}
.style_pagination__XIdWV div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__XIdWV div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__XIdWV div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__XIdWV div:hover, .style_pagination__XIdWV div.style_active__OEW5p {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__XIdWV div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__XIdWV div.style_disabled__ASDED, .style_pagination__XIdWV div.style_active__OEW5p, .style_pagination__XIdWV div.style_info__badzj {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__XIdWV div.style_disabled__ASDED {
  color: var(--color-gray-700);
}
.style_pagination__XIdWV div:last-child, .style_pagination__XIdWV div:first-child {
  padding: 0 10px;
}
.style_pagination__XIdWV div:last-child {
  border-right: none;
}
.style_pagination__XIdWV button:last-child, .style_pagination__XIdWV button:first-child {
  padding: 0 10px;
}
.style_pagination__XIdWV button:last-child {
  border-right: none;
}

.style_interface__8eUNM {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__K6KK5 {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__K6KK5 {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__K6KK5 > div {
    width: 100%;
  }
}
.style_interface_heading_row__uqn1C {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__uqn1C {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__zwMjm {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__zwMjm {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__zwMjm > div {
    width: 100%;
  }
}
.style_interface_foot__7-u1d {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__7-u1d {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__LMlGP {
  gap: 15px;
  padding: 70px 0;
}

.style_main__zvidG {
  gap: 20px;
}
.style_main_container__K7bUF {
  width: 100%;
  position: relative;
  border: 2px dashed var(--color-gray-400);
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
}
.style_main_container_file__s9mXr {
  flex-direction: column;
  width: 100%;
  gap: 16px;
}
.style_main_container_file_box__v5YiM {
  gap: 10px;
}
.style_main_container_file_name__UYWkh {
  font-size: 18px;
  font-weight: 400;
  color: var(--text-color-W);
}
.style_main_container_file_emails__EyF-M {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-white-500);
  white-space: nowrap;
}
.style_main_container_file_icon__i3jdU {
  color: var(--text-color-W);
}
.style_main_container_close__WVqlJ {
  position: absolute;
  right: 0;
  top: 0;
  padding-right: 15px;
  padding-top: 15px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.5;
}
.style_main_container_close__WVqlJ:hover {
  opacity: 1;
}
.style_main__zvidG button {
  width: max-content;
}
.style_main_loadingProcess__jr1Ts {
  width: 100%;
  background-color: var(--bg-color);
  border: 1px solid var(--border);
  padding: 12px;
  border-radius: 8px;
}
.style_main_loadingProcess_text__1S9O2 {
  gap: 4px;
}
.style_main_loadingProcess_text_title__o5\\+QL {
  color: var(--text-color-W);
}
.style_main_loadingProcess_text_sub__U\\+QNg {
  font-size: 14px;
  color: var(--color-white-500);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/components/molecules/BulkLead/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;ADkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACfF;;ADuBA;EACE,aAAA;EACA,sBAAA;ACpBF;;ACnBA;EACI,qBAAA;ADsBJ;;ACpBA;EACI,eAAA;EACA,cAAA;ADuBJ;ACtBI;EACE,0BAAA;ADwBN;;ACpBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADuBJ;;ACpBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADuBR;ACrBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADuBR;ACrBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADuBR;ACrBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADuBR;AE/DE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EDyBV;AACF;ACvBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADyBR;AEzEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;ED2BV;AACF;ACzBI;EACI,mBAAA;AD2BR;AElFE;EDsDE;IAGQ,mBAAA;ED6BV;AACF;;AGrFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHwFF;AGvFE;;EAEE,gBAAA;AHyFJ;AGvFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AHyFJ;AGxFI;EACE,+BAAA;EACA,uCAAA;AH0FN;AGvFE;EACE,4BAAA;AHyFJ;;AI7GA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJgHF;AI7GE;EACE,gBAAA;EACA,eAAA;AJ+GJ;AI7GE;EACE,gBAAA;AJ+GJ;AI3GE;EACE,oCAAA;AJ6GJ;AI3GE;EAEE,oCAAA;AJ4GJ;AI1GE;EACE,4CAAA;AJ4GJ;AI1GE;EACE,uCAAA;EACA,mCAAA;AJ4GJ;AI1GE;EACE,oCAAA;EACA,gCAAA;AJ4GJ;AI1GE;EAEE,4CAAA;EACA,kCAAA;AJ2GJ;AIzGE;EACE,6BAAA;EACA,uCAAA;AJ2GJ;;AIxGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ2GF;AIxGE;EACE,gBAAA;EACA,eAAA;AJ0GJ;AIxGE;EACE,gBAAA;AJ0GJ;AItGE;EAEE,oCAAA;AJuGJ;AIrGE;EACE,4CAAA;AJuGJ;AIrGE;EACE,mBAAA;EACA,cAAA;AJuGJ;AIrGE;EAEE,4CAAA;EACA,kCAAA;AJsGJ;AIpGE;EACE,6BAAA;EACA,uCAAA;AJsGJ;;AK9LA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ALiMF;AK/LI;;EAEE,kBAAA;EACA,mBAAA;ALiMN;AK/LI;;EAEE,6BAAA;ALiMN;AK/LI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ALiMN;AK9LM;EACE,mBAAA;ALgMR;AK9LM;EACE,6BAAA;ALgMR;;AMpNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANsNJ;AMpNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANqNR;AMpNQ;EACI,2BAAA;EACA,8BAAA;ANsNZ;AMpNQ;EACI,4BAAA;EACA,+BAAA;ANsNZ;AErPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENuNV;AACF;AMtNQ;EACI,eAAA;EACA,oBAAA;ANwNZ;AMtNQ;EACI,4BAAA;ANwNZ;AMrNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANsNR;AMrNQ;EACI,2BAAA;EACA,8BAAA;ANuNZ;AMrNQ;EACI,4BAAA;EACA,+BAAA;ANuNZ;AMrNQ;ECrCJ,eAAA;EACA,qFAAA;AP6PJ;AEvRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;ENyNV;AACF;AMxNQ;EACI,eAAA;EACA,oBAAA;AN0NZ;AMxNQ;EACI,4BAAA;AN0NZ;AMvNI;EACI,eAAA;ANyNR;AMvNI;EACI,kBAAA;ANyNR;AMvNI;EACI,eAAA;ANyNR;AMvNI;EACI,kBAAA;ANyNR;;AQ3SA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;AR8SF;AQ5SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR6SJ;AErUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ER+SJ;EQ9SI;IACE,WAAA;ERgTN;AACF;AQ9SI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;AR+SN;AEnVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ERiTN;AACF;AQ9SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR+SJ;AEnWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ERiTJ;EQhTI;IACE,WAAA;ERkTN;AACF;AQ/SE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ARiTJ;AEjXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ERmTJ;AACF;AQjTE;EAEE,SAAA;EACA,eAAA;ARkTJ;;AA3XA;EAEE,SAAA;AA6XF;AA5XE;EACE,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA8XJ;AA5XI;EAEE,sBAAA;EACA,WAAA;EACA,SAAA;AA6XN;AA3XM;EAEE,SAAA;AA4XR;AAzXM;EACE,eAAA;EACA,gBAAA;EACA,0BSXO;ATsYf;AAxXM;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AA0XR;AAxXM;EACE,0BSrBO;AT+Yf;AAtXI;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAwXN;AAvXM;EACE,UAAA;AAyXR;AApXE;EACE,kBAAA;AAsXJ;AAnXE;EAEE,WAAA;EACA,iCS5DO;ET6DP,+BAAA;EACA,aAAA;EACA,kBAAA;AAoXJ;AAlXI;EAEE,QAAA;AAmXN;AAjXM;EACE,0BSzDO;AT4af;AAhXM;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;AAkXR","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"/src/assets/scss/\" as *;\n.main {\n  @extend %flex-column-align;\n  gap: 20px;\n  &_container {\n    width: 100%;\n    position: relative;\n    border: 2px dashed var(--color-gray-400);\n    border-radius: 8px;\n    padding: 40px 20px;\n    text-align: center;\n\n    &_file {\n      @extend %flex-center;\n      flex-direction: column;\n      width: 100%;\n      gap: 16px;\n\n      &_box {\n        @extend %flex-align;\n        gap: 10px;\n      }\n\n      &_name {\n        font-size: 18px;\n        font-weight: 400;\n        color: $text-color-W;\n      }\n\n      &_emails {\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--color-white-500);\n        white-space: nowrap;\n      }\n      &_icon {\n        color: $text-color-W;\n      }\n    }\n\n    &_close {\n      position: absolute;\n      right: 0;\n      top: 0;\n      padding-right: 15px;\n      padding-top: 15px;\n      line-height: 1;\n      cursor: pointer;\n      opacity: .5;\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  button {\n    width: max-content;\n  }\n\n  &_loadingProcess {\n    @extend %flex-justify-between-center;\n    width: 100%;\n    background-color: $bg-color;\n    border: 1px solid $border;\n    padding: 12px;\n    border-radius: 8px;\n\n    &_text {\n      @extend %flex-column;\n      gap: 4px;\n\n      &_title {\n        color: $text-color-W;\n      }\n\n      &_sub {\n        font-size: 14px;\n        color: var(--color-white-500);\n        font-weight: 400;\n      }\n    }\n  }\n}\n","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container_file": `style_main_container_file__s9mXr`,
	"pagination": `style_pagination__XIdWV`,
	"main_container_file_box": `style_main_container_file_box__v5YiM`,
	"interface_heading_row": `style_interface_heading_row__uqn1C`,
	"main": `style_main__zvidG`,
	"interface_noResults": `style_interface_noResults__LMlGP`,
	"main_loadingProcess": `style_main_loadingProcess__jr1Ts`,
	"main_loadingProcess_text": `style_main_loadingProcess_text__1S9O2`,
	"interface": `style_interface__8eUNM`,
	"link": `style_link__EUpCY`,
	"text-gradient-intel": `style_text-gradient-intel__Xtxjv`,
	"text-xs": `style_text-xs__Ls-5f`,
	"text-sm": `style_text-sm__ZlXDn`,
	"interface_heading": `style_interface_heading__K6KK5`,
	"interface_footer": `style_interface_footer__zwMjm`,
	"text-base": `style_text-base__15Eqj`,
	"text-lg": `style_text-lg__mlgWy`,
	"text-xl": `style_text-xl__0vCMt`,
	"text-leading": `style_text-leading__5QNE9`,
	"breadcumb": `style_breadcumb__8VDkq`,
	"divider": `style_divider__7rjmZ`,
	"badge": `style_badge__Ngccm`,
	"xs": `style_xs__3JeHE`,
	"sm": `style_sm__aTCsi`,
	"primary": `style_primary__0UNZ-`,
	"pm": `style_pm__OViGf`,
	"sd": `style_sd__j6p3H`,
	"Likely": `style_Likely__6ywQE`,
	"Unvalidated": `style_Unvalidated__k6gmN`,
	"Verified": `style_Verified__AyrgH`,
	"green": `style_green__72aDW`,
	"off": `style_off__KHVvi`,
	"badgeTable": `style_badgeTable__OgKko`,
	"table": `style_table__CHLCd`,
	"style-1": `style_style-1__F225W`,
	"label": `style_label__C+u0u`,
	"noBorder": `style_noBorder__z2V9f`,
	"disabled": `style_disabled__ASDED`,
	"active": `style_active__OEW5p`,
	"info": `style_info__badzj`,
	"interface_foot": `style_interface_foot__7-u1d`,
	"main_container": `style_main_container__K7bUF`,
	"main_container_file_name": `style_main_container_file_name__UYWkh`,
	"main_container_file_emails": `style_main_container_file_emails__EyF-M`,
	"main_container_file_icon": `style_main_container_file_icon__i3jdU`,
	"main_container_close": `style_main_container_close__WVqlJ`,
	"main_loadingProcess_text_title": `style_main_loadingProcess_text_title__o5+QL`,
	"main_loadingProcess_text_sub": `style_main_loadingProcess_text_sub__U+QNg`
};
export default ___CSS_LOADER_EXPORT___;
